// @flow
import SdkConfiguration from '../utils/SdkConfiguration';

export default class ViewConstants {

  static IMAGE_DEFAULT_RESTAURANT_LOGO() {
    return `${SdkConfiguration.getDomainUrl()}/img/user_default_picture.png` // TODO: change
  }

  static IMAGE_DEFAULT_RESTAURANT() {
    return `${SdkConfiguration.getDomainUrl()}/img/default_restaurant.png`
  }

  static IMAGE_UPLOAD_BTN() {
    return `${SdkConfiguration.getDomainUrl()}/img/upload_update.png`
  }

  static IMAGE_DELETE_BTN() {
    return `${SdkConfiguration.getDomainUrl()}/img/upload_delete.png`
  }

  static IMAGE_RESTORE_BTN() {
    return `${SdkConfiguration.getDomainUrl()}/img/upload_restore.png`
  }

  static IMAGE_UPLOAD_PLACEHOLDER() {
    return `${SdkConfiguration.getDomainUrl()}/img/draughtboard.png`
  }

  static IMAGE_LOADING_BAR() {
    return `${SdkConfiguration.getDomainUrl()}/img/loading-bars.svg`
  }

  static IMAGE_DEFAULT_USER_PICTURE() {
    return `${SdkConfiguration.getDomainUrl()}/img/user_default_picture.png`
  }

  static IMAGE_USER_DEFAULT_PICTURE() {
    return `${SdkConfiguration.getDomainUrl()}/img/user_default_picture.png`
  }

  static KIOSK_ORDER_LOCALES() {
    return [
      'fr_FR',
      'en_GB',
      'de_DE',
      'es_ES',
    ];
  }

};



// WEBPACK FOOTER //
// ./sdk/scripts/constants/ViewConstants.js